class MapConfig
  @set: (lat, lng, zoom) =>
    localStorage.removeItem('map-center')
    localStorage.setItem('map-center', [lat, lng])
    if zoom
      localStorage.removeItem('map-zoom')
      localStorage.setItem('map-zoom', zoom)

window.map_config = MapConfig

class Map
  # options.home_center = [lat, lng] domovskeho pohledu obce, options.home_zoom.
  # Pouzije se jako vychozi pohled, kdyz uzivatel nema ulozenou pozici
  # v localStorage (viz setMapView).
  constructor: (map_id, controls = {}, options = {}) ->
    @map_id = map_id
    @controls = controls
    @home_center = options.home_center or null
    @home_zoom = options.home_zoom or null
    @map = L.map @map_id,
      attributionControl: true,
      zoomAnimation: true,
      zoomSnap: 0.1,
      zoomDelta: 1,
      wheelDelta: 0.1,
      wheelPxPerZoomLevel: 100
    # vypnout autopan popupu - mapa se pri otevreni popupu nema posouvat
    L.Popup.prototype.options.autoPan = false
    @layers = []
    @groups = []
    @base_layers = []
    @aerial_layers = []
    @selected_base_layer = undefined
    @selected_layers = []
    @patterns = {}

    try
      @expanded = if localStorage.getItem('map-controls-expanded') == 'false' then false else true
    catch
      @expanded = true

    @map_collapse_content = jQuery('#' + map_id + '-collapsed-content')
    @map_collapse_controller = @map_collapse_content.closest('.map-toggle-controller')

    # Debug mode: ?debug=1 v URL nebo localStorage.setItem('map-debug', '1')
    # Vypnutí: localStorage.removeItem('map-debug') a smazat ?debug=1 z URL
    @_debug = false
    try
      urlDebug = /[?&]debug=1\b/.test(window.location.search)
      lsDebug = localStorage.getItem('map-debug') == '1'
      @_debug = urlDebug or lsDebug
    catch
      @_debug = false
    if @_debug
      console.log '[MAP DEBUG] zapnuto. Vypnout: localStorage.removeItem(\'map-debug\') + smazat ?debug=1'
      window.onerror = (msg, src, line, col, err) ->
        console.log '[MAP DEBUG] window.onerror:', msg, '@', (src or '?') + ':' + line + ':' + col
        if err and err.stack
          console.log '[MAP DEBUG] stack:', err.stack
        return false

    @setMapView()

    return

  # Vychozi pohled pri nacteni mapy. Priorita:
  #   1) ulozena pozice v localStorage (posledni pohled uzivatele)
  #   2) domovsky pohled obce (@home_center/@home_zoom z template contextu
  #      home_lat/home_lng/home_zoom) - ma ho starosta i staff se vybranou obci
  #   3) az nakonec hardcoded stred CR se zoomem 13
  # Bod 2 driv chybel: 'map_config.set' v sablone plni localStorage jen kdyz je
  # nastaveny jednorazovy flag set_default_map_position / selected_city_changed
  # (viz get_default_map_configuration - flag se hned vypina a uklada). Pri
  # DALSICH prihlasenich uz se tag nevygeneroval, a kdyz uzivatel nemel v
  # localStorage nic (jiny prohlizec, smazana data, anonymni okno), spadlo to na
  # bod 3 = stred CR / zoom 13 -> vyrez ~16 km siroky, ~38 km od obce
  # ("oddali me to na velikost skoro kraje").
  setMapView: ->
    center = null
    zoom = null

    try
      stored = localStorage.getItem('map-center')
      if stored
        parts = stored.split(",")
        if parts.length == 2 and not isNaN(parseFloat(parts[0])) and not isNaN(parseFloat(parts[1]))
          center = [parseFloat(parts[0]), parseFloat(parts[1])]
      storedZoom = parseInt(localStorage.getItem('map-zoom'))
      if storedZoom == parseInt(storedZoom, 10)
        zoom = storedZoom
    catch
      center = null

    # Domovsky pohled obce jako fallback pred stredem CR.
    if not center? and @home_center?
      center = @home_center
      zoom = @home_zoom if not zoom? and @home_zoom?

    center = [49.51272684615392, 17.630996704101566] if not center?
    zoom = 13 if not zoom?

    @map.invalidateSize()
    @map.setView center, zoom

  setMapConfig: ->
      center = @map.getCenter()
      map_config.set(center["lat"], center["lng"], @map.getZoom())

  attachEvents: ->
    $('#'+@map_id+'-controls').click @expandControls
    $('#'+@map_id+'-controls-close').click @collapseControls
    $('#'+@map_id+'-fullscreen-button').click @toggleFullscreen

    $('#'+@map_id+'-legend-toggle').click (event) =>
      $('#'+@map_id+'-legend').toggle()
      return

    @map.on 'zoomend', (event) =>
      @setMapConfig()

    @map.on 'moveend', (event) =>
      @setMapConfig()

    @map_collapse_content.on 'shown.bs.collapse', (event) =>
      @setMapView()
      @map_collapse_controller.addClass('expanded')
      @map_collapse_controller.removeClass('collapsed')
      localStorage.setItem('map-shown', "true")

    @map_collapse_content.on 'hidden.bs.collapse', (event) =>
      @setMapView()
      @map_collapse_controller.removeClass('expanded')
      @map_collapse_controller.addClass('collapsed')
      localStorage.setItem('map-shown', "false")

    if localStorage.getItem('map-shown') == "true" or localStorage.getItem('map-shown') == null
      @map_collapse_content.collapse('show')
    return

  addLayer: (name, identifier, layer, active, fit, group, on_top, is_fill, exclusive_group, parent_layers, child_layers) ->
    if @_debug
      featureCount = '?'
      try
        if layer and layer.getLayers
          featureCount = layer.getLayers().length
      console.log '[MAP DEBUG] addLayer:', identifier, '(active=' + active + ', features=' + featureCount + ', group=' + group + ')'
    savedChoice = @getLayerChoice identifier
    if savedChoice?
      active = savedChoice
    # initControls bezi synchronne pred dojezdem AJAXu, takze checkbox uz zde
    # existuje a ma zapocitany i stav nadrazenych skupin (vrstva ve vypnute
    # skupine = odskrtnuta). Ma proto prednost pred ulozenou volbou vrstvy samotne,
    # jinak by AJAX rozsvitil vrstvu ve vypnute skupine.
    existingCheckbox = $('#'+@map_id+'-'+identifier+'-layer-checkbox')
    if existingCheckbox.length
      active = existingCheckbox.prop('checked') == true
    @layers[identifier] =
      name: name
      identifier: identifier
      layer: layer
      active: active
      on_top: on_top
      is_fill: is_fill
      exclusive_group: exclusive_group
      parent_layers: parent_layers
      child_layers: child_layers
    @map.addLayer layer
    layerOpacity = @getLayerOpacityChoice identifier
    layerOpacity = Math.min(layerOpacity, layer.options.opacity);


    if layer instanceof L.TileLayer or layer instanceof L.ImageOverlay
      layer.setOpacity(layerOpacity)
    else
      $('.'+identifier).css 'opacity', layerOpacity

    $('#'+@map_id+'-legend-'+identifier).show()
    for top_layer_identifier, top_layer of @layers
      if top_layer.on_top and top_layer.active
        top_layer.layer.bringToFront()
    if not active
      @toggleLayer identifier, false, false
    else
      # Vrstva je zapnuta -> projisteni smazat pripadna stara hide-pravidla.
      # Bez tohoto by vrstva s checkbox=checked, ktera ale zustala schovana
      # (stare CSS pravidlo / rozjety stav z minule session), sla videt az po
      # 2. prokliku checkboxu (1. proklik = vypnout, 2. = zapnout = sweep).
      @toggleLayer identifier, true, false
    # addLayer je jediny zdroj pravdy o viditelnosti vrstvy pri loadu (bezi
    # async az po synchronnim initControls -> checkbox uz existuje). Srovnat
    # vizualni stav checkboxu s realnym stavem vrstvy, aby se nerozesly
    # (checkbox=on, vrstva=hidden -> "az po 2. zapnuti"). Tyka se i vrstev s
    # vice controlled_layers (Tridy/Stavy + _fill), kde checkbox nese jen
    # primarni identifier.
    checkbox = $('#'+@map_id+'-'+identifier+'-layer-checkbox')
    if checkbox.length
      checkbox.prop('checked', active)
#      if fit
#        try
#          @map.fitBounds layer.getBounds()
#        catch
    if group?
      @addLayerToGroup identifier, group
    else
      @addLayerToGroup identifier, 'no-group'
    return

#  addGeoJSONLayer: (name, geo_json, active, style, fit) ->
#    layer = new L.geoJSON geo_json,
#      style: style
#    @layers[name] =
#      layer: layer
#      active: active
#    if active
#      @map.addLayer layer
#      if fit
#        @map.fitBounds layer.getBounds()
#    return

  addBaseLayer: (identifier, name, url, settings, wms=false) ->
    if wms
      layer = new L.tileLayer.wms(url, settings)
    else
      layer = new L.tileLayer(url, settings)
    @base_layers[name] = layer
    return

  addAerialLayer: (identifier, name, url, settings, wms=false) ->
    if wms
      layer = new L.tileLayer.wms(url, settings)
    else
      layer = new L.tileLayer(url, settings)
    @aerial_layers[name] = layer
    return

  selectInitialBaseLayer: =>
    saved = localStorage.getItem('map-base-layer')
    if @base_layers[saved] != undefined or @aerial_layers[saved] != undefined
      name = saved
    else
      name = "Open Street Map"
    @selectBaseLayer(name)

  selectBaseLayer: (name) =>
    # pojistka: neznama/prazdna vrstva by odebrala starou a nepridala zadnou -> prazdna mapa
    if not name or (not @base_layers[name] and not @aerial_layers[name])
      return
    if @selected_base_layer
      if @base_layers[@selected_base_layer]
        @map.removeLayer @base_layers[@selected_base_layer]
      else if @aerial_layers[@selected_base_layer]
        @map.removeLayer @aerial_layers[@selected_base_layer]
    if @base_layers[name]
      @map.addLayer @base_layers[name]
    else if @aerial_layers[name]
      @map.addLayer @aerial_layers[name]
    @selected_base_layer = name
    for top_layer_name, top_layer of @layers
      if top_layer.on_top and top_layer.active
        top_layer.layer.bringToFront()
    localStorage.setItem('map-base-layer', @selected_base_layer)
    # Update radio buttons in both menus
    $('input[name="optradio"], input[name="optradio-aerial"]').prop('checked', false)
    $('input[name="optradio"][value="' + name + '"], input[name="optradio-aerial"][value="' + name + '"]').prop('checked', true)
    return

  toggleLayer: (identifiers, activate, saveChoice=true) =>
    if identifiers == undefined
      return

    if @_debug
      console.log '[MAP DEBUG] toggleLayer:', identifiers, '→ activate=' + activate, '(known: ' + (Object.keys(@layers).join(',') or '∅') + ')'
    for identifier in identifiers.split(',')
      if saveChoice
        @saveLayerChoice identifier, activate
      # Vrstva ještě nemusí být zaregistrovaná (AJAX dosud nedojel,
      # nebo geometrie byla prázdná a addLayer se nezavolal).
      unless @layers[identifier]?
        if @_debug
          console.warn '[MAP DEBUG] toggleLayer SKIP — vrstva neexistuje:', identifier
        continue
      @layers[identifier].active = activate
      layerObj = @layers[identifier].layer
      # Pokud je to tileLayer nebo imageOverlay, použijeme addLayer/removeLayer
      if layerObj instanceof L.TileLayer or layerObj instanceof L.ImageOverlay
        if activate
          @map.addLayer layerObj
        else
          @map.removeLayer layerObj
      layer_elements = $('path.'+identifier+', div.leaflet-marker-icon.'+identifier+', div.'+identifier+'_tooltip span, div.leaflet-layer.'+identifier)
      if activate
        layer_elements.show()
        # Mazat odzadu — deleteRule posouvá indexy, dopředná iterace by pravidla přeskakovala.
        sheet = $('#'+@map_id+'-wrapper style').get(0).sheet
        i = sheet.rules.length - 1
        while i >= 0
          selector = sheet.rules[i].selectorText
          if selector == 'text.'+identifier+'_tooltip' or selector == 'img.leaflet-marker-icon.'+identifier or selector == 'path.'+identifier or selector == 'div.leaflet-layer.'+identifier
            sheet.deleteRule(i)
          i--
        $('#'+@map_id+'-legend-'+identifier).show()
        for top_layer_name, top_layer of @layers
          if top_layer.exclusive_group? and @layers[identifier].exclusive_group? and top_layer.identifier != identifier and top_layer.exclusive_group == @layers[identifier].exclusive_group
            # Vypnout konkurencni exclusive vrstvu vcetne jeji _fill varianty.
            # Drive se volal .click() na CSV checkbox, coz bylo krehke:
            # kdyz checkbox jeste neexistoval (AJAX pred initControls), fill se
            # nevypnul a localStorage se rozesel (linie=false, fill=true -> bile linie).
            exclusiveIds = [top_layer.identifier]
            if @layers[top_layer.identifier + '_fill']?
              exclusiveIds.push(top_layer.identifier + '_fill')
            @toggleLayer exclusiveIds.join(','), false
            # Synchronizovat vizualni stav checkboxu (bez dalsiho toggle).
            $('#'+@map_id+'-'+top_layer.identifier+'-layer-checkbox').prop('checked', false)
          if top_layer.on_top and top_layer.active
            top_layer.layer.bringToFront()
      else
        layer_elements.hide()
        # Linie/polygony (SVG path) i WMS dlaždice schováváme i přes CSS pravidlo.
        # Inline .hide() Leaflet při překreslení (bringToFront/zoom/wiggle) smaže,
        # proto by se vrstva bez tohoto pravidla po překreslení znovu objevila.
        $('#'+@map_id+'-wrapper style').get(0).sheet.insertRule('path.'+identifier+' {display: none;}')
        $('#'+@map_id+'-wrapper style').get(0).sheet.insertRule('div.leaflet-layer.'+identifier+' {display: none;}')
        $('#'+@map_id+'-wrapper style').get(0).sheet.insertRule('text.'+identifier+'_tooltip {visibility: hidden;}')
        $('#'+@map_id+'-wrapper style').get(0).sheet.insertRule('img.leaflet-marker-icon.'+identifier+' {display: none;}')
        $('#'+@map_id+'-legend-'+identifier).hide()
        # Funkcni podvrstvy (napr. seweragepipe_rainwater/_waste/_combined) kresli
        # stejnou geometrii jako rodic, ale jako samostatne DOM <path> sady. Vypnuti
        # rodice je musi schovat take, jinak combined/waste linie zustanou viditelne.
        # Togglujeme primo pres toggleLayer (ne pres .click() na checkbox - ten je
        # krehky, kdyz checkbox jeste neexistuje nebo neni v ocekavanem stavu).
        if @layers[identifier].child_layers? and @layers[identifier].child_layers.length
          for child in @layers[identifier].child_layers
            if @layers[child]?
              @toggleLayer child, false
              $('#'+@map_id+'-'+child+'-layer-checkbox').prop('checked', false)
        for l_name, l of @layers
          if l.parent_layers? and l.parent_layers.length
            some_parent_displayed = false
            for pl in l.parent_layers
              if $('#'+@map_id+'-'+pl+'-layer-checkbox').prop('checked')
                some_parent_displayed = true
                break
            if not some_parent_displayed and $('#'+@map_id+'-'+l.identifier+'-layer-checkbox').prop('checked')
              # Drive .click() - krehke. Togglujeme primo a checkbox jen vizualne odskrtneme.
              @toggleLayer l.identifier, false
              $('#'+@map_id+'-'+l.identifier+'-layer-checkbox').prop('checked', false)
    return

  # Verze klice ulozenych voleb vrstev. Bump (_v2) zneplatni stare nekonzistentni
  # hodnoty v localStorage (napr. rozjety state linie=false / fill=true), takze
  # vrstvy jednou spadnou na aktualni server default. Pri dalsi zmene defaultu bumpni dal.
  layerChoiceSuffix: '_displayed_v2'

  saveLayerChoice: (identifier, activate) =>
    value = ''
    if activate
      value = 'true'
    else
      value = 'false'

    localStorage.setItem(identifier + @layerChoiceSuffix, value)
    return

  getLayerChoice: (identifier) =>
    try
      value = localStorage.getItem(identifier + @layerChoiceSuffix)
      if value == 'true'
        return true
      if value == 'false'
        return false
      return null
    catch
      return null

  getLayerOpacityChoice: (identifier) =>
    try
      layerOpacity = localStorage.getItem(identifier + '_opacity')
    catch
      layerOpacity = 1

    if !layerOpacity
      layerOpacity = 1
    layerOpacity

  toggleGroup: (identifiers, activate) =>
    identifiers = identifiers.split('|')
    groupIdentifier = identifiers[0]
#    layerIdentifiers = identifiers[1].split(',')
    groupBox = $('#group-box-'+groupIdentifier)

    @saveLayerChoice 'group_' + groupIdentifier, activate

    # Viditelnost vrstev a sbaleni panelu jsou dve rozdilne veci. Drive se pri
    # odskrtnuti skupiny volalo groupBox.hide(), takze uzivatel zaroven ztratil
    # pristup k jednotlivym podvrstvam. Collapse zustava vyhradne na sipce ▼
    # (vlastni .collapsed trida + vlastni localStorage klic).
    #
    # POZOR: zde zamerne NENI ani groupBox.show(). Kdyz byl panel SBALENY
    # (.collapsed -> CSS 'display: none'), jQuery .show() na nem zapsal INLINE
    # 'display: block', ktery uz CSS pravidlo
    # '.group-wrapper.collapsed .group-box { display: none }' neprebije.
    # Dusledek: zapnuti sbalene skupiny ji samo rozbalilo a slo ji sbalit uz jen
    # po refreshi (kdy se inline styl neobnovi). U rozbalene skupiny .show() nic
    # nedelal (mel uz 'display: table'), proto se to projevovalo jen u nekterych.
    # S 'display' tedy nesmi zachazet nic jineho nez collapse na sipce.

    self = @
    # Jen PRIME potomky boxu - '.checkbox' (vrstva) nebo '.group-wrapper' >
    # '.group-header' (vnorena skupina). Hlubsi urovne si zpracuje rekurzivni
    # toggleGroup. Pri pouziti find() by se vrstvy uvnitr podskupiny zpracovaly
    # dvakrat a rozesel by se jejich stav v localStorage.
    directInputs = groupBox.children('.checkbox').find('input[type="checkbox"]')
      .add(groupBox.children('.group-wrapper').children('.group-header').find('input[type="checkbox"]'))
    directInputs.each () ->
      isChecked = $(this).prop('checked') == true or $(this).prop('checked') == 'checked'

      # Vnorena skupina: delegovat na toggleGroup, ne na toggleLayer. Hodnota
      # checkboxu skupiny je 'identifier|vrstva1,vrstva2', kterou toggleLayer
      # splituje podle carky -> prvni "identifier" byl 'graves_by_contract|unpaid_grave',
      # coz jako vrstva neexistuje, takze se ta vrstva nikdy neschovala/nezapnula.
      if $(this).attr('data-is-group') == 'true'
        if activate
          # Pri zapnuti nadskupiny respektovat vychozi stav podskupiny ze serveru
          # a drive ulozenou volbu uzivatele.
          return if isChecked
          savedGroupChoice = self.getLayerChoice 'group_' + $(this).attr('data-group-identifier')
          shouldEnableGroup = if savedGroupChoice? then savedGroupChoice else $(this).attr('data-default-active') != 'false'
          if shouldEnableGroup
            $(this).prop('checked', true)
            self.toggleGroup $(this).val(), true
        else
          if isChecked
            $(this).prop('checked', false)
          # Vypnout obsah podskupiny vzdy, i kdyz jeji checkbox uz odskrtnuty je -
          # jinak by v mape zustaly viset vrstvy z rozesleho stavu.
          self.toggleGroup $(this).val(), false
        return

      if activate
        # Při zapnutí skupiny respektovat výchozí stav vrstvy nebo dříve uloženou volbu.
        # Vrstvy s data-default-active="false" se zapnou jen pokud je uživatel dříve explicitně zapnul.
        # Vrstvy s data-never-on-group="true" se při zapnutí skupiny nikdy nezapínají
        # a vynutíme jejich odškrtnutí včetně uložení volby do localStorage.
        neverOnGroup = $(this).attr('data-never-on-group') == 'true'
        if neverOnGroup
          if isChecked
            # Drive $(this).click() - krehke (zalezi na navazanem handleru a poradi).
            # Togglujeme primo a checkbox jen vizualne odskrtneme.
            $(this).prop('checked', false)
            self.toggleLayer $(this).val(), false
          else
            # Pojistka: i když je nyní odškrtnutý, vynutíme uložení 'false'
            # pro každou jednotlivou controlled vrstvu, aby localStorage
            # nikdy nedržel zapnutý stav u vrstvy s never_on_group.
            for ident in $(this).val().split(',')
              self.saveLayerChoice ident, false
          return
        return if isChecked
        defaultActive = $(this).attr('data-default-active') != 'false'
        shouldEnable = defaultActive
        if shouldEnable
          $(this).prop('checked', true)
          self.toggleLayer $(this).val(), true
      else
        if isChecked
          $(this).prop('checked', false)
        # Vypnout vzdy, i kdyz je checkbox uz odskrtnuty. Vrstva muze byt v mape
        # viditelna i s odskrtnutym checkboxem (rozesly stav z drivejsi session
        # nebo z AJAXu, ktery dojel po initControls) - podminene vypinani presne
        # tyhle pripady preskakovalo a vrstva zustala viset v mape.
        self.toggleLayer $(this).val(), false
      return
    return

  initControls: ->

    $('#menu-icon').click ->
      menu = $('#map-controls-base-layers-menu')
      $('#aerial-controls-menu').hide()
      $('#aerial-icon').removeClass('active')
      $('#aerial-icon img').attr('src', '/static/images/glyphicons-airlane.png')
      if menu.css('display') == 'none'
        menu.show()
        $('#menu-icon').addClass('active')
        $('#menu-icon img').attr('src', '/static/images/layers_icon-white.png')
      else
        menu.hide()
        $('#menu-icon').removeClass('active')
        $('#menu-icon img').attr('src', '/static/images/layers_icon.png')

    $('#aerial-icon').click ->
      menu = $('#aerial-controls-menu')
      $('#map-controls-base-layers-menu').hide()
      $('#menu-icon').removeClass('active')
      $('#menu-icon img').attr('src', '/static/images/layers_icon.png')
      if menu.css('display') == 'none'
        menu.show()
        $('#aerial-icon').addClass('active')
        $('#aerial-icon img').attr('src', '/static/images/glyphicons-airlane-white.png')
      else
        menu.hide()
        $('#aerial-icon').removeClass('active')
        $('#aerial-icon img').attr('src', '/static/images/glyphicons-airlane.png')

    # Klik kamkoliv na layers-menu-container (mimo samotné menu) zavře aerial menu
    $('#layers-menu-container').click (e) ->
      if not $(e.target).closest('#aerial-controls-menu, #aerial-icon').length
        $('#aerial-controls-menu').hide()
        $('#aerial-icon').removeClass('active')
        $('#aerial-icon img').attr('src', '/static/images/glyphicons-airlane.png')

    # Klik kamkoliv na aerial-menu-container (mimo samotné menu) zavře base layers menu
    $('#aerial-menu-container').click (e) ->
      if not $(e.target).closest('#map-controls-base-layers-menu, #menu-icon').length
        $('#map-controls-base-layers-menu').hide()
        $('#menu-icon').removeClass('active')
        $('#menu-icon img').attr('src', '/static/images/layers_icon.png')

    if @expanded
      $('#'+@map_id+'-controls').addClass('expanded')
      $('#'+@map_id+'-wrapper').addClass('controls-expanded')
      $('#menu-icon').addClass('expanded')

    menuContainer = $('#' + @map_id + '-controls-base-layers-menu')
    menuContainer.empty()


    for name, layer of @base_layers
      checked = if name == @selected_base_layer then 'checked' else ''
      radio = $('<div class="radio layout-custom-radio"><label><input type="radio" id="radio-'+@slugify(name)+'" name="optradio" value="'+name+'" '+checked+'><span class="radio-image '+@slugify(name)+'"></span> '+name+'</label></div>')

      radio.click (e) =>
        # e.target muze byt label/span (bez .value) kdyz uzivatel klikne mimo input;
        # cti hodnotu vzdy z inputu uvnitr radio divu
        @selectBaseLayer($(e.currentTarget).find('input').val())
        $('#menu-toggle').prop('checked', false)

      menuContainer.append(radio)

    # Aerial layers menu
    aerialContainer = $('#aerial-controls-menu')
    aerialContainer.empty()

    for name, layer of @aerial_layers
      checked = if name == @selected_base_layer then 'checked' else ''
      radio = $('<div class="radio layout-custom-radio"><label><input type="radio" id="radio-'+@slugify(name)+'" name="optradio-aerial" value="'+name+'" '+checked+'><span class="radio-image '+@slugify(name)+'"></span> '+name+'</label></div>')

      radio.click (e) =>
        @selectBaseLayer($(e.currentTarget).find('input').val())

      aerialContainer.append(radio)

    # Reset aktivní sekce před renderováním
    @currentSectionContent = null

    for item in @controls.controls
      @renderControlItem item, 0, $('#'+@map_id+'-controls-layers')

    @attachEvents()
    return

  # ancestorsActive = jsou VSECHNY nadrazene skupiny zapnute? Vrstva ve vypnute
  # skupine nesmi po reloadu svitit, i kdyz ma v localStorage 'true' (jinak
  # "hroby po Ctrl+F5 skacou random").
  renderControlItem: (item, level, parentElement, ancestorsActive = true) =>

    if item.type == 'group'
      checked = if item.active? and item.active == false then '' else 'checked'
      savedChoice = @getLayerChoice 'group_' + item.identifier
      if savedChoice?
        checked = if savedChoice then 'checked' else ''
      controlledLayers = @getGroupsLayers item
      # Vychozi stav skupiny ze serveru ('active': False). Nese ho checkbox skupiny
      # stejne jako u vrstev, aby toggleGroup u nadskupiny nezapinal podskupinu,
      # ktera ma byt vychozne vypnuta (napr. 'Hroby podle smlouvy').
      groupDefaultActive = if item.active? and item.active == false then 'false' else 'true'
      groupWrapperElement = $('<div class="group-wrapper"></div>')

      # Načíst uložený stav collapse
      savedCollapse = localStorage.getItem('group_collapse_' + item.identifier)
      if savedCollapse == 'true'
        groupWrapperElement.addClass('collapsed')

      groupHeader = $('<div class="checkbox group-header">' +
            '<span class="collapse-icon">▼</span>' +
            '<label>' +
              '<input type="checkbox" data-is-group="true" data-group-identifier="'+item.identifier+'" data-default-active="'+groupDefaultActive+'" value="'+item.identifier+'|'+controlledLayers.join(',')+'" '+checked+'>' +
              item.name +
            '</label>' +
          '</div>')

      # Click na checkbox pro zapnutí/vypnutí skupiny
      groupHeader.find('input').click ((e) =>
        e.stopPropagation()
        @toggleGroup(e.target.value, e.target.checked)
      )

      # Click na ikonu pro collapse/expand
      groupHeader.find('.collapse-icon').click (e) =>
        e.stopPropagation()
        wrapper = $(e.target).closest('.group-wrapper')
        wrapper.toggleClass('collapsed')
        isCollapsed = wrapper.hasClass('collapsed')
        localStorage.setItem('group_collapse_' + item.identifier, isCollapsed)
        return

      groupWrapperElement.append groupHeader

      groupBox = $('<div class="group-box" id="group-box-' + item.identifier + '"></div>')
      groupWrapperElement.append groupBox
      parentElement.append groupWrapperElement

      # Zde uz zamerne zadne groupBox.hide() - odskrtnuta skupina neznamena
      # sbaleny panel (viz toggleGroup). Sbaleni resi jen ulozeny stav collapse
      # na .group-wrapper vyse.

      for subitem in item.items
        @renderControlItem subitem, level + 1, groupBox, (ancestorsActive and checked == 'checked')

    if item.type == 'layer'
      checked = if item.active? and item.active == false then '' else 'checked'
      defaultActive = if item.active? and item.active == false then 'false' else 'true'
      neverOnGroup = if item.never_on_group? and item.never_on_group == true then 'true' else 'false'
      # Vrstvy s never_on_group ignorují uloženou volbu z localStorage —
      # vždy startují odškrtnuté podle item.active.
      if neverOnGroup != 'true'
        # POZOR: saveLayerChoice uklada volbu po jednotlivych identifikatorech
        # (toggleLayer si controlled_layers rozdeli pres splitnuti carkou),
        # zatimco addLayer cte ulozenou volbu rovnez po jednom identifikatoru.
        # Drive se zde cetl spojeny klic controlled_layers.join(',') -> u vrstev
        # s vice controlled_layers (Tridy/Stavy + _fill) to byl klic, ktery se
        # NIKDY neukladal, takze checkbox spadl na server default a rozesel se
        # se skutecnym stavem vrstvy ("az po 2. zapnuti"). Cteme proto stav
        # primarni vrstvy (controlled_layers[0]) stejnym klicem jako addLayer.
        savedChoice = @getLayerChoice item.controlled_layers[0]
        if savedChoice?
          checked = if savedChoice then 'checked' else ''

      # Nadrazena skupina je vypnuta -> vrstva startuje vypnuta bez ohledu na
      # ulozenou volbu. Volbu v localStorage zamerne NEprepisujeme, aby se po
      # opetovnem zapnuti skupiny vratil puvodni vyber uzivatele.
      if not ancestorsActive
        checked = ''

      checkbox = $('<div class="checkbox"><label><input id="'+@map_id+'-'+item.identifier+'-layer-checkbox" type="checkbox" value="'+item.controlled_layers.join(',')+'" data-default-active="'+defaultActive+'" data-never-on-group="'+neverOnGroup+'" '+checked+'>'+item.name+'</label></div>')
      checkbox.click ((e) => @toggleLayer(e.target.value, e.target.checked))

      opacityControl = $('<span class="glyphicon glyphicon-adjust tooltip-toggle"></span>')
      opacityControl.addClass(item.controlled_layers[0] + '_opacity_control')

      opacityControl.click {'layerIdentifier': item.controlled_layers[0], 'mapInstance': @}, (e) ->
        e.preventDefault()

        try
          layerOpacity = localStorage.getItem(item.controlled_layers[0] + '_opacity')
        catch
          layerOpacity = 1

        if !layerOpacity
          layerOpacity = 1

        if $('.opacity_slider').siblings('.tooltip-toggle').length > 0
          $('.opacity_slider').remove()
          return

        $('.opacity_slider').remove()
        opacitySlider = $('<div class="opacity_slider"></div>')
        opacitySlider.focusout (e) ->
          $('.opacity_slider').remove()
          return
        opacitySlider.click (e) ->
          e.preventDefault()
          return
        $(this).after(opacitySlider)
        opacitySlider.slider
          min: 0
          max: 1
          step: 0.01
          value: layerOpacity

        opacitySlider.on 'slidechange', null, {'layerIdentifier': item.controlled_layers[0], 'mapInstance': e.data.mapInstance}, (e, ui) ->
          layerIdentifier = e.data.layerIdentifier
          mapInstance = e.data.mapInstance

          # Zkusíme najít vrstvu v mapě
          if mapInstance.layers[layerIdentifier]?
            layerObj = mapInstance.layers[layerIdentifier].layer
            # Pokud je to TileLayer nebo ImageOverlay, použijeme Leaflet API
            if layerObj instanceof L.TileLayer or layerObj instanceof L.ImageOverlay
              layerObj.setOpacity(ui.value)
            else
              # Pro ostatní vrstvy použijeme CSS
              $('.'+layerIdentifier).css 'opacity', ui.value
          else
            # Fallback na CSS, pokud vrstvu nenajdeme
            $('.'+layerIdentifier).css 'opacity', ui.value

          localStorage.setItem(layerIdentifier + '_opacity', ui.value)
          return
        return

      checkbox.find('input').after(opacityControl)

      if item.has_query?
        queryIcon = $('<span class="glyphicon glyphicon-info-sign query-toggle" title="Informace o prvku"></span>')
        checkbox.find('input').after(queryIcon)

      if item.has_hover?
        hoverIcon = $('<span class="glyphicon glyphicon-info-sign hover-toggle" title="Zvýraznění najetím"></span>')
        checkbox.find('input').after(hoverIcon)

      if not item.no_tooltip?
        tooltipToggle = $('<span class="glyphicon glyphicon-tag tooltip-toggle"></span>')
        tooltipToggle.addClass(item.controlled_layers[0] + '_tooltip_toggle')

        try
          layerTooltipOn = localStorage.getItem(item.controlled_layers[0] + '_tooltip_on')
        catch
          layerTooltipOn = 'false'

        if layerTooltipOn == null
          layerTooltipOn = 'false'

        if layerTooltipOn == 'false'
          tooltipToggle.addClass('tooltip-toggle-off')
          $('#'+@map_id+'-wrapper style').get(0).sheet.insertRule('.' + item.controlled_layers[0] + '_tooltip {display: none !important;}')

        tooltipToggle.click {'layerIdentifier': item.controlled_layers[0], 'mapId': @map_id}, (e) ->
          e.preventDefault()
          if $('.' + e.data.layerIdentifier + '_tooltip_toggle').hasClass('tooltip-toggle-off')
            for i, rule of $('#'+e.data.mapId+'-wrapper style').get(0).sheet.rules
              if rule.selectorText == '.' + e.data.layerIdentifier + '_tooltip'
                $('#'+e.data.mapId+'-wrapper style').get(0).sheet.deleteRule(i)

            $('.' + e.data.layerIdentifier + '_tooltip_toggle').removeClass 'tooltip-toggle-off'
            localStorage.setItem(e.data.layerIdentifier + '_tooltip_on', 'true')
          else
            $('#'+e.data.mapId+'-wrapper style').get(0).sheet.insertRule('.' + e.data.layerIdentifier + '_tooltip {display: none !important;}')
            $('.' + e.data.layerIdentifier + '_tooltip_toggle').addClass 'tooltip-toggle-off'
            localStorage.setItem(e.data.layerIdentifier + '_tooltip_on', 'false')
          return

        checkbox.find('input').after(tooltipToggle)

      # Kontrola, zda má tato vrstva vytvořit novou sekci s nadpisem
      sectionConfig = null
      if item.identifier == 'dtm_zps_linie_body'
        sectionConfig = {id: 'dtm', icon: 'fa fa-globe', title: 'Digitální technická mapa ČR'}
      else if item.identifier == 'mapproxy_lms_zborovice_1961'
        sectionConfig = {id: 'lms', icon: 'fa fa-star', title: 'Mapy obce'}
      else if item.identifier == 'katastr'
        sectionConfig = {id: 'katastr', icon: 'fa fa-pencil', title: 'Katastrální mapa ČR'}
      else if item.identifier == 'verVybavenost'
        sectionConfig = {id: 'topic', icon: 'fa fa-map-signs', title: 'Tematické vrstvy'}
      # POZOR: id musi byt UNIKATNI - je z nej klic 'section_collapse_<id>' v
      # localStorage i data-section-id. Tyto tri sekce drive sdilely id 'place',
      # takze si prepisovaly stav navzajem (sbaleni jedne = sbaleni vsech tri,
      # posledni zapis vyhral) a po refreshi se rozbalovaly spolecne.
      else if item.identifier == 'hustZalidneni'
        sectionConfig = {id: 'place', icon: 'fa fa-tree', title: 'Územní vrstvy'}
      else if item.identifier == 'orto2000'
        sectionConfig = {id: 'archive', icon: 'glyphicon glyphicon-time', title: 'Archivní a historické mapy'}
      else if item.identifier == 'voda'
        sectionConfig = {id: 'nature', icon: 'fa fa-picture-o', title: 'Přírodní a terénní vrstvy'}

      if sectionConfig?
        # Vytvoříme wrapper pro celou sekci
        sectionWrapper = $('<div class="section-wrapper" data-section-id="' + sectionConfig.id + '"></div>')

        # Načíst uložený stav collapse pro sekci
        savedCollapse = localStorage.getItem('section_collapse_' + sectionConfig.id)
        if savedCollapse == 'true'
          sectionWrapper.addClass('collapsed')

        # Vytvoříme nadpis s ikonou pro collapse
        sectionHeader = $('<div class="map-controls-title section-header">' +
          '<span class="section-collapse-icon">▼</span>' +
          '<i class="' + sectionConfig.icon + '" style="margin-right: 5px"></i>' +
          '<b>' + sectionConfig.title + '</b>' +
          '</div>')

        # Click handler pro collapse/expand
        sectionHeader.click (e) =>
          wrapper = $(e.currentTarget).closest('.section-wrapper')
          wrapper.toggleClass('collapsed')
          isCollapsed = wrapper.hasClass('collapsed')
          sectionId = wrapper.data('section-id')
          localStorage.setItem('section_collapse_' + sectionId, isCollapsed)
          return

        sectionWrapper.append sectionHeader

        # Vytvoříme kontejner pro obsah sekce
        sectionContent = $('<div class="section-content"></div>')
        sectionWrapper.append sectionContent

        # Přidáme wrapper do parent elementu
        parentElement.append sectionWrapper

        # Nastavíme aktuální sekci pro následující vrstvy
        @currentSectionContent = sectionContent

      # Pokud máme aktivní sekci, přidáváme do ní, jinak do původního parentElement
      targetElement = if @currentSectionContent? then @currentSectionContent else parentElement
      targetElement.append checkbox

    return

  getGroupsLayers: (group) =>
    layerIdentifiers = []
    for item in group.items
      if item.controlled_layers?
        layerIdentifiers = layerIdentifiers.concat(item.controlled_layers)

      if item.type == 'group'
        layerIdentifiers = layerIdentifiers.concat(@getGroupsLayers(item))
    layerIdentifiers

  toggleControls: =>
    if @expanded
      @collapseControls()
    else
      @expandControls()
    return

  expandControls: =>
    @expanded = true
    $('#'+@map_id+'-controls').addClass('expanded')
    $('#'+@map_id+'-wrapper').addClass('controls-expanded')
    $('#menu-icon').addClass('expanded')
    localStorage.setItem('map-controls-expanded', 'true')
    return

  collapseControls: (e) =>
    e.stopPropagation()
    @expanded = false
    $('#'+@map_id+'-controls').removeClass('expanded')
    $('#'+@map_id+'-wrapper').removeClass('controls-expanded')
    $('#menu-icon').removeClass('expanded')
    localStorage.setItem('map-controls-expanded', 'false')
    return

  addLayerToGroup: (layer_identifier, group_name) =>
    for group in @groups
      if group.name == group_name
        group.layers.push layer_identifier
        return
    @groups.push
      'name': group_name
      'layers': [ layer_identifier ]
    return

  slugify: (st) =>
    st = st.toLowerCase()
    st = st.replace(/[\u00C0-\u00C5]/ig, 'a')
    st = st.replace(/[\u00C8-\u00CB]/ig, 'e')
    st = st.replace(/[\u00CC-\u00CF]/ig, 'i')
    st = st.replace(/[\u00D2-\u00D6]/ig, 'o')
    st = st.replace(/[\u00D9-\u00DC]/ig, 'u')
    st = st.replace(/[\u00D1]/ig, 'n')
    st = st.replace(/[^a-z0-9 ]+/gi, '')
    st = st.trim().replace(RegExp(' ', 'g'), '-')
    st = st.replace(/[\-]{2}/g, '')
    st.replace /[^a-z\- ]*/gi, ''

  # Vyhledavani objektu v mape (Select2 -> id_for_search). Otevre popup a zacentruje.
  goToFeature: (identifier) =>
    for feature_id, feature of @map._layers
      if feature.id_for_search? and feature.id_for_search == identifier
        if feature._popup? and not feature._popup.isOpen()
          feature.fire 'click'
        else if feature.fire?
          feature.fire 'click'
        @lastSearchedFeature = feature   # pro tlacitko "vycentrovat"
        @centerOnFeature feature
        return
    return

  # Zacentruje mapu na feature. Body (getLatLng) -> setView, geometrie (getBounds)
  # -> fitBounds. Bez teto vetve se linie/plochy (bez getLatLng) nezacentrovaly a
  # popup se otevrel mimo viewport (autoPan je zamerne vypnuty).
  centerOnFeature: (feature) =>
    return unless feature?
    @map.invalidateSize()
    if feature.getLatLng?
      currentZoom = @map.getZoom()
      zoom = if currentZoom < 18 then 20 else currentZoom
      @map.setView feature.getLatLng(), zoom, animate: false
    else if feature.getBounds?
      @map.fitBounds feature.getBounds(), maxZoom: 20, animate: false

  # Znovu zacentruje na naposledy vyhledany objekt (tlacitko ve vyhledavacim okne).
  recenterLastSearched: =>
    @centerOnFeature @lastSearchedFeature

  # Obalka (bounds) vsech nactenych datovych vrstev = fakticky rozsah obce.
  # Iteruje @layers, sklada bounds z kazde skupiny co ma getBounds a je neprazdna.
  # Vraci L.LatLngBounds nebo null (zadna data).
  getDataBounds: =>
    bounds = null
    for identifier, entry of @layers
      layer = entry.layer
      continue unless layer?
      # jen datove vrstvy (ne podkladove dlazdice/ortofoto)
      continue if layer instanceof L.TileLayer or layer instanceof L.ImageOverlay
      continue unless layer.getBounds?
      try
        lb = layer.getBounds()
      catch e
        continue
      continue unless lb? and lb.isValid?() and lb.isValid()
      if bounds? then bounds.extend(lb) else bounds = L.latLngBounds(lb.getSouthWest(), lb.getNorthEast())
    return bounds

  # Home tlacitko (domecek) = vychozi pohled na obec. Kdyz obec ma souradnice
  # (center predany z template contextu home_lat/home_lng), pouzij je. Jinak
  # fallback na obalku vsech dat v mape (fitBounds) - funguje i bez rucne
  # vyplnenych souradnic obce. NIKDY se nepamatuje posledni pozice.
  # invalidateSize + animate:false: mapa muze byt v collapsed panelu (viz home crash).
  goHome: (center, zoom) =>
    @map.invalidateSize()
    if center? and (not isNaN(center[0])) and (not isNaN(center[1]))
      @map.setView center, zoom, animate: false
    else
      bounds = @getDataBounds()
      if bounds?
        @map.fitBounds bounds, maxZoom: 19, animate: false

  # Zoom + zvyrazneni prvku podle jeho layer.identifier (= "<layer_def.identifier>_<pk>").
  # Pouzivane z gridu (klik/oznaceni radku). Zvlada body (getLatLng) i geometrie (getBounds).
  # Vraci true kdyz prvek nasel, jinak false (feature nemusi byt v mape - vrstva vypnuta).
  #
  # Nejdriv presna shoda (fixni identifier vrstvy jako 'light_point', 'grave', ...).
  # Kdyz selze, zkusi PREFIX+PK match pro vrstvy s variabilnim suffixem:
  # communal/plan maji identifier 'communalarea-<drawing>_<pk>' (drawing na gridu neni,
  # a jedno pk muze byt ve vice drawing vrstvach) -> grid posle 'communalarea_<pk>' a my
  # najdeme feature jejiz identifier zacina na '<rodina>-' a konci na '_<pk>'.
  goToFeatureByIdentifier: (identifier) =>
    feature = @findFeatureByIdentifier identifier
    return false unless feature?
    if feature._popup? and not feature._popup.isOpen()
      feature.fire 'click'
    else if feature.fire?
      feature.fire 'click'
    # invalidateSize + animate:false: mapa muze byt v collapsed panelu bez platneho
    # layoutu -> animovany zoom (_tryAnimatedZoom) by padal na null 'lat' (stejne jako home).
    @map.invalidateSize()
    if feature.getLatLng?
      currentZoom = @map.getZoom()
      zoom = if currentZoom < 18 then 20 else currentZoom
      @map.setView feature.getLatLng(), zoom, animate: false
    else if feature.getBounds?
      @map.fitBounds feature.getBounds(), maxZoom: 20, animate: false
    return true

  # Najde feature v mape podle identifieru. Nejdriv presna shoda; kdyz selze,
  # rozlozi 'rodina_pk' a hleda feature s identifierem zacinajicim 'rodina-' a
  # koncicim '_pk' (communal/plan variabilni drawing suffix). Vraci feature nebo null.
  findFeatureByIdentifier: (identifier) =>
    for feature_id, feature of @map._layers
      if feature.identifier? and feature.identifier == identifier
        return feature
    # fallback prefix+pk (identifier musi mit tvar '<rodina>_<pk>')
    lastUnderscore = identifier.lastIndexOf '_'
    return null if lastUnderscore <= 0
    family = identifier.substring 0, lastUnderscore
    pkSuffix = identifier.substring lastUnderscore   # vcetne '_' -> '_<pk>'
    prefix = family + '-'
    for feature_id, feature of @map._layers
      id = feature.identifier
      if id? and id.indexOf(prefix) == 0 and id.length - pkSuffix.length == id.lastIndexOf(pkSuffix)
        return feature
    return null

  # Zvyrazneni objektu vybranych plochou (filtr gridu). Dostane seznam
  # identifikatoru '<rodina>_<pk>' a obarvi odpovidajici features v mape.
  # Puvodni styl se schova do feature._preAreaSelectStyle, aby se dal vratit.
  highlightAreaSelection: (identifiers) =>
    return unless identifiers?
    @clearAreaSelection()
    @_areaSelected = []
    for identifier in identifiers
      feature = @findFeatureByIdentifier identifier
      continue unless feature?
      if feature.setStyle?
        feature._preAreaSelectStyle =
          color: feature.options.color
          weight: feature.options.weight
          fillColor: feature.options.fillColor
          fillOpacity: feature.options.fillOpacity
        feature.setStyle
          color: '#ff6600'
          weight: 4
          fillColor: '#ff6600'
          fillOpacity: 0.4
        feature.bringToFront?()
      else if feature._icon?
        # divIcon markery nemaji setStyle -> zvyrazneni pres CSS tridu.
        L.DomUtil.addClass feature._icon, 'map-area-selected'
      @_areaSelected.push feature
    return

  # Vrati zvyraznenym objektum puvodni styl.
  clearAreaSelection: () =>
    return unless @_areaSelected?
    for feature in @_areaSelected
      if feature._preAreaSelectStyle? and feature.setStyle?
        feature.setStyle feature._preAreaSelectStyle
        delete feature._preAreaSelectStyle
      else if feature._icon?
        L.DomUtil.removeClass feature._icon, 'map-area-selected'
    @_areaSelected = []
    return

  wiggle: () =>
    @map.zoomOut null, 'animate': false
    @map.zoomIn null, 'animate': false
    return

  toggleFullscreen: () =>
    jQuery('#'+@map_id+'-wrapper').toggleClass('fullscreen')
    @map.invalidateSize()
    return

window.Map = Map
